$shm_hitalama_map_page_arrow $mol_view
	from /number
		0
		0
	to /number
		0
		0
	kind \
	sub /
		<= Line $mol_view
		<= Head $mol_view
	style *
		^
		left <= left_px \0px
		top <= top_px \0px
		width <= length_px \0px
		transform <= transform \rotate(0deg)
	attr *
		^
		shm_hitalama_map_page_arrow_kind <= kind
